import DetailsGeneral from '../../../_common/elements/details/DetailsGeneral';
import css from './SDGeneral.module.css';

import toShort from '../../../../../services/utils/dateParser';

function SDGeneral({ staff, toggleModal }) {
    let content = {};

    //image link only
    content.image = `url(https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png`
    
    //Array of elements
    content.info = [
        (<p>Date of birth: <strong>{toShort(staff.staffDoB)}</strong></p>),
        // (<p>Place of birth: <strong>{staff.studentPoB}</strong></p>),
        (<p>Email: <strong>{staff.staffEmail}</strong></p>),
        (<p>Phone: <strong>{staff.staffPhone}</strong></p>),
    ];

    // Single element
    content.notes = (
        <p className={css.notes} style={{ fontSize: '1rem' }}>
            <strong>Notes:</strong>
            <br />
            {staff.staffNotes}
        </p>
    );

    //Single element
    content.additional = ( <div></div> )

    let functions = {};
    functions.edit = toggleModal;

    return <DetailsGeneral content={content} functions={functions}/>;
}

export default SDGeneral;

// {student.studentPhone && (
//     <QRCode
//         value={student.studentPhone}
//         level="L"
//         size={128}
//         viewBox={`0 0 128 128`}
//         bgColor="#e0ecfa"
//         fgColor="#060628"
//         title="Phone"
//     />
// )}
